function SiteFooter() {
  return (
    <footer className="border-t border-outlineVariant/40 bg-surfaceContainerLow py-10">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-6 px-4 md:flex-row md:px-8">
        <div>
          <p className="text-lg font-bold text-onSurface">Krystal Software</p>
          <p className="text-xs text-onSurfaceVariant">
            © 2026 Krystal Software Consultancy. Todos los derechos reservados.
          </p>
        </div>
        <div className="flex gap-8 text-xs font-semibold text-onSurfaceVariant">
          <a href="https://www.linkedin.com" target="_blank" rel="noreferrer" className="hover:text-primary">
            LinkedIn
          </a>
          <a href="https://github.com" target="_blank" rel="noreferrer" className="hover:text-primary">
            GitHub
          </a>
          <a href="https://x.com" target="_blank" rel="noreferrer" className="hover:text-primary">
            X / Twitter
          </a>
        </div>
      </div>
    </footer>
  );
}

export default SiteFooter;
